module.exports = {
  "$id": "companyRegister",
  "type": "object",
  "title": "代理人注册",
  "properties": {
    "registerAgentUserInfo": {
      "title": "代理用户",
      "type": "object",
      "properties": {
        "login": {
          "title": "用户名",
          "type": "string",
          "format": "loginName"
        },
        "password": {
          "title": "密码",
          "type": "string",
          "format": "password"
        },
        "confirmPassword": {
          "title": "确认密码",
          "type": "string",
          "format": "password",
          "const": {
            "$data": "1/password"
          }
        },
        "phone": {
          "title": "手机号",
          "type": "string",
          "format": "phone"
        },
        "email": {
          "title": "邮箱",
          "type": "string",
          "format": "email"
        },
        "chiSurname": {
          "title": "中文姓",
          "type": "string",
          "customValidate": "zhLastName"
        },
        "chiName": {
          "title": "中文名",
          "type": "string",
          "customValidate": "zhFirstName"
        },
      },
      "required": [
        "login",
        "password",
        "confirmPassword",
        "chiSurname",
        "chiName"
      ]
    },
    "registerAgentInfo": {
      "title": "代理机构",
      "type": "object",
      "properties": {
        "chiName": {
          "title": "企业名称",
          "type": "string"
        },
        "agentType": {
          "title": "企业类型",
          "type": "string"
        },
        "contactName": {
          "title": "业务员联系人",
          "type": "string"
        },
        "department": {
          "title": "所属营业部",
          "type": "string"
        },
        "officeNo": {
          "title": "OFFICE号",
          "type": "string"
        },
        "phoneNo": {
          "title": "办公电话",
          "type": "string"
        },
        "country": {
          "title": "地区",
          "type": "array"
        }
      },
      "required": [
        "chiName",
        "agentType",
        "contactName",
        "department",
        "officeNo",
        "country"
      ]
    }
  },
  "required": [
    "registerAgentUserInfo",
    "registerAgentInfo"
  ],
  "errorMessage": {
    "registerAgentInfo.chiName": {
      "required": "请输入企业名称"
    },
    "registerAgentInfo.agentType": {
      "required": "请选择企业类型"
    },
    "registerAgentInfo.contactName": {
      "required": "请输入业务员联系人姓名"
    },
    "registerAgentInfo.department": {
      "required": "请输入所属营业部"
    },
    "registerAgentInfo.officeNo": {
      "required": "请输入航班office号"
    },
    "registerAgentInfo.phoneNo": {
      "required": "请输入有效办公联系电话"
    },
    "registerAgentInfo.country": {
      "required": "请选择地区"
    },
    "registerAgentUserInfo.login": {
      "message": "请输入用户名,长度6-40位",
      "required": "用户名不能为空"
    },
    "registerAgentUserInfo.password": {
      "message": "请输入密码,8位-20位",
      "required": "密码不能为空"
    },
    "registerAgentUserInfo.confirmPassword": {
      "message": "两次密码输入不一致！",
      "pattern": "请输入密码,8位-20位",
      "required": "请再次输入密码"
    },
    "registerAgentUserInfo.phone": {
      "message": "请输入11位中国大陆手机号码",
      "required": "手机号码不能为空"
    },
    "registerAgentUserInfo.email": {
      "message": "请输入正确的电子邮箱",
      "required": "电子邮箱不能为空"
    },
    "registerAgentUserInfo.chiSurname": {
      "required": "中文姓不能为空"
    },
    "registerAgentUserInfo.chiName": {
      "required": "中文名不能为空"
    }
  }
}
